@if (authService.isLoggedIn) {
  <div class="profile-dialog-container relative p-6 md:p-8 flex flex-col items-center max-w-full">

    <button mat-icon-button class="close-button absolute top-3 right-3" (click)="closeDialog($event)" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>

    <div class="flex flex-col items-center text-center w-full mb-6">
      <div class="relative group mb-4">
        <div class="avatar-wrapper relative">
          @if (authService.currentUser.photoURL) {
            <img src="{{authService.currentUser.photoURL}}"
              class="profile-avatar-image shadow-xl rounded-full h-32 w-32 md:h-36 md:w-36 object-cover border-4 transition-transform duration-300 group-hover:scale-[1.02]" alt="user profile image">
          } @else if (authService.currentUser.displayName) {
            <div class="profile-avatar-initial shadow-xl font-bold rounded-full flex items-center justify-center text-4xl h-32 w-32 md:h-36 md:w-36 border-4">
              {{authService.currentUser.displayName.substring(0, 1).toUpperCase()}}
            </div>
          } @else {
            <div class="profile-avatar-placeholder shadow-xl rounded-full flex items-center justify-center h-32 w-32 md:h-36 md:w-36 border-4">
              <mat-icon class="text-4xl">person</mat-icon>
            </div>
          }

          @if (!hideForm) {
            <button mat-mini-fab color="primary"
              class="edit-photo-button absolute right-0 bottom-1 scale-90 md:scale-100 shadow-md transition-transform hover:scale-105"
              (click)="$event.stopPropagation(); profileImage.click()" type="button" aria-label="Edit photo">
              <mat-icon>edit</mat-icon>
            </button>
          }
        </div>
      </div>

      <input #profileImage type="file" accept="image/*" class="hidden" (change)="upload($event)" (click)="$event.stopPropagation();">

      <div class="user-meta mt-2">
        <h2 class="profile-name m-0 text-2xl font-extrabold tracking-tight">
          {{ authService.currentUser.firstName }} {{ authService.currentUser.lastName }}
        </h2>
        <p class="profile-email text-sm mt-1 font-medium flex items-center justify-center gap-1">
          <mat-icon class="profile-email-icon text-sm w-4 h-4 leading-none">email</mat-icon>
          {{ authService.currentUser.email }}
        </p>
        @if (authService.currentUser.company) {
          <span class="profile-company-badge inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold mt-2">
            <mat-icon class="text-xs w-3.5 h-3.5 leading-none">business</mat-icon>
            {{ authService.currentUser.company }}
          </span>
        }
      </div>
    </div>

    @if (hideForm) {
      <div class="profile-actions flex flex-col sm:flex-row gap-3 w-full max-w-xs justify-center mt-2 profile-divider pt-6">
        <button mat-flat-button color="primary" class="rounded-xl px-6 py-2 flex-1" (click)="edit($event)">
          <mat-icon class="mr-2">edit_note</mat-icon>
          {{ 'account.edit.profile' | translate }}
        </button>
        <button mat-stroked-button class="rounded-xl px-6 py-2 flex-1" (click)="authService.signOut(); closeDialog($event)">
          <mat-icon class="mr-2">exit_to_app</mat-icon>
          {{ 'DASHBOARD.LOGOUT' | translate }}
        </button>
      </div>
    }

    @if (!hideForm) {
      <form [formGroup]="accountForm" (click)="$event.stopPropagation()" class="profile-form w-full max-w-sm profile-divider pt-6">
        <div class="flex flex-col gap-4">
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>{{ 'ACCOUNT.FIRST_NAME' | translate }}</mat-label>
            <input matInput type="text" autocomplete="off" data-lpignore="true" formControlName="firstName">
            <mat-icon matPrefix class="profile-field-icon mr-2">person_outline</mat-icon>
            @if (accountForm.controls.firstName.hasError('required')) {
              <mat-error>{{ 'common.required.field' | translate }}</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full">
            <mat-label>{{ 'name' | translate }}</mat-label>
            <input matInput type="text" autocomplete="off" data-lpignore="true" formControlName="lastName">
            <mat-icon matPrefix class="profile-field-icon mr-2">person_outline</mat-icon>
            @if (accountForm.controls.lastName.hasError('required')) {
              <mat-error>{{ 'common.required.field' | translate }}</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full">
            <mat-label>{{ 'ACCOUNT.COMPANY' | translate }}</mat-label>
            <input matInput type="text" autocomplete="off" data-lpignore="true" formControlName="company">
            <mat-icon matPrefix class="profile-field-icon mr-2">business</mat-icon>
            @if (accountForm.controls.company.hasError('required')) {
              <mat-error>{{ 'common.required.field' | translate }}</mat-error>
            }
          </mat-form-field>

          <div class="flex flex-row gap-3 mt-4 w-full">
            <button mat-stroked-button class="rounded-xl flex-1 py-2" (click)="cancel($event)" [disabled]="disable" type="button">
              {{ 'common.cancel.edit' | translate }}
            </button>
            <button mat-flat-button color="primary" class="rounded-xl flex-1 py-2" (click)="update(accountForm.value, $event)" [disabled]="accountForm.invalid || disable" type="submit">
              @if (progress) {
                <mat-spinner diameter="18" class="mr-2"></mat-spinner>
              }
              {{ 'ACCOUNT.UPDATE_PROFILE' | translate }}
            </button>
          </div>
        </div>
      </form>
    }
  </div>
}
